import React from 'react';
import { motion } from 'framer-motion';
export const PainSection = () => {
  return <section className="py-20 bg-white border-y border-neutral-200" data-id="element-181">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="prose prose-lg mx-auto text-neutral-700" data-id="element-183">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-brand-700" data-id="element-184">
            ¿Te suena familiar?
          </h2>

          <p className="text-xl font-medium text-neutral-900 text-center" data-id="element-185">
            Mandás el presupuesto y del otro lado solo hay silencio.
          </p>

          <div className="my-12 p-6 rounded-xl bg-cream-dark border border-neutral-200" data-id="element-186">
            <p className="text-neutral-600 mb-4 font-medium" data-id="element-187">
              Y empezás a pensar lo de siempre:
            </p>
            <ul className="space-y-4 text-lg font-medium text-neutral-800 list-none pl-0" data-id="element-188">
              <li className="flex items-center gap-3" data-id="element-189">
                <span className="text-brand-600" data-id="element-190">"</span>No hay plata en el
                mercado.<span className="text-brand-600" data-id="element-191">"</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-192">
                <span className="text-brand-600" data-id="element-193">"</span>Mi rubro está muerto.
                <span className="text-brand-600" data-id="element-194">"</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-195">
                <span className="text-brand-600" data-id="element-196">"</span>Quizás tengo que bajar
                mis precios.<span className="text-brand-600" data-id="element-197">"</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-198">
                <span className="text-brand-600" data-id="element-199">"</span>No sé qué más hacer.
                <span className="text-brand-600" data-id="element-200">"</span>
              </li>
            </ul>
          </div>

          <h3 className="text-2xl font-bold text-neutral-900 mt-12 mb-6" data-id="element-201">
            Pará un segundo.
          </h3>
          <p data-id="element-202">
            Porque lo que estás pensando es comprensible, pero está{' '}
            <strong className="text-brand-600" data-id="element-203">100% equivocado.</strong>
          </p>

          <div className="my-8 pl-6 border-l-4 border-brand-500" data-id="element-204">
            <p className="text-xl font-medium text-neutral-900 m-0" data-id="element-205">
              El problema no es el mercado.
            </p>
            <p className="text-xl font-medium text-neutral-900 mt-2 m-0" data-id="element-206">
              El problema es que nadie te enseñó a vender cuando el mercado no
              ayuda.
            </p>
          </div>

          <p className="text-lg" data-id="element-207">
            Y eso, a diferencia del mercado,{' '}
            <strong className="text-neutral-900" data-id="element-208">
              tiene solución concreta.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
};